var map = {
	"./Mariposa.png": "b923",
	"./ecobanka.png": "a14c",
	"./ecobanka_blanco.png": "0be2",
	"./ecobanka_claro.png": "171d",
	"./myneofintech.png": "cb94",
	"./myneofintech_blanco.png": "5ff8",
	"./myneofintech_blanco_old.png": "d4da",
	"./myneofintech_old.png": "bdfa",
	"./neolicitador.png": "19aa",
	"./neolicitador_blanco.png": "32d8",
	"./newfranquicia.png": "5331",
	"./newfranquicia_blanco.png": "0a94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "69ae";